import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { Alert } from '../../../GeneralApplication/Application/components'
import { useResponsive } from '../../../../utils/hooks'

type ConfirmationModalProps = {
  visible: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}

export const ConfirmationModal: FC<ConfirmationModalProps> = observer(
  (props) => {
    const { t } = useTranslation()
    const { sm } = useResponsive()
    const { visible, onClose, onConfirm } = props

    const logoutButton = {
      testID: 'logout-logout',
      label: t('logOut'),
      status: 'basic',
      onPress: onConfirm,
    }

    const cancelButton = {
      testID: 'logout-continue-session',
      label: t('continue-session'),
      status: 'primary',
      onPress: onClose,
    }

    return (
      <Alert
        visible={visible}
        verticalButtons={!sm}
        onClose={onClose}
        buttons={
          sm ? [logoutButton, cancelButton] : [cancelButton, logoutButton]
        }
        buttonsContainerStyle={{
          alignSelf: 'center',
          width: sm ? '90%' : 280,
        }}
        title={t('are-you-sure-to-logout')}
        titleStyle={{ width: 280, fontWeight: 600, marginTop: 16 }}
      />
    )
  },
)
